module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stateDisplay === 'KeHoachDieuDongTau') ? _c('jx-hanghai-ke-hoach-dieu-dong', {
    ref: "KeHoachDieuDongTau",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : (_vm.stateDisplay === 'KeHoachDieuDongTau2') ? _c('jx-hanghai-ke-hoach-dieu-dong-2', {
    ref: "KeHoachDieuDongTau2",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : (_vm.stateDisplay === 'TauTrongCang') ? _c('jx-hanghai-tau-trong-cang', {
    ref: "TauTrongCang",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  }) : _c('jx-hanghai-vi-tri-tau-roi-cang', {
    ref: "ViTriTauTaiCang",
    attrs: {
      "type": _vm.type,
      "documentTypeCode": _vm.documentTypeCode,
      "documentStatusCode": _vm.documentStatusCode,
      "stateDisplay": _vm.stateDisplay
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c299d58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeTraCuu.vue
// module id = 720
// module chunks = 1